import React, { useEffect } from "react";
import { useDragControls, useMotionValue, useAnimation } from "framer-motion";
import { X } from "lucide-react";
import useMeasure from "react-use-measure";
import {
	Container,
	Drawer,
	Header,
	DragHandle,
	CloseButton,
	Content,
	ContentWrapper,
	Title,
} from "./styled";

export const BottomSheet = ({ children, isOpen, title, onClose }) => {
	const controls = useDragControls();
	const y = useMotionValue(0);

	const backdropControls = useAnimation();
	const drawerControls = useAnimation();

	const [drawerRef, { height }] = useMeasure();

	const handleClose = async () => {
		// Fade out backdrop
		backdropControls.start({ opacity: 0 });

		const yStart = typeof y.get() === "number" ? y.get() : 0;

		// Animate drawer down
		await drawerControls.start({
			y: height || 500,
			transition: { ease: "easeInOut" },
		});

		onClose();
	};

	useEffect(() => {
		if (isOpen) {
			document.body.classList.add("overflow-hidden");

			backdropControls.start({
				opacity: 1,
				transition: { duration: 0.2 },
			});

			drawerControls.start({
				y: 0,
				transition: { ease: "easeInOut" },
			});
		} else {
			document.body.classList.remove("overflow-hidden");
		}
	}, [isOpen, drawerControls, backdropControls]);

	return (
		<>
			{isOpen && (
				<Container
					initial={{ opacity: 0 }}
					animate={backdropControls}
					onClick={handleClose}
					data-testid="drag-close-drawer-container"
				>
					<Drawer
						ref={drawerRef}
						id="drawer"
						onClick={(e) => e.stopPropagation()}
						initial={{ y: "100%" }}
						animate={drawerControls}
						style={{ y }}
						transition={{
							ease: "easeInOut",
						}}
						onDragEnd={() => {
							if (y.get() > 50) {
								handleClose();
							}
						}}
						drag="y"
						dragControls={controls}
						dragListener={false}
						dragConstraints={{ top: 0, bottom: 0 }}
						dragElastic={{ top: 0, bottom: 0.5 }}
					>
						<Header>
							<DragHandle
								onPointerDown={(e) => controls.start(e)}
								type="button"
							/>
							<CloseButton
								data-testid="drag-close-drawer-close-button"
								type="button"
								onClick={handleClose}
							>
								<X width={24} height={24} />
							</CloseButton>
						</Header>
						<Content>
							<ContentWrapper>
								<Title>{title}</Title>
								{children}
							</ContentWrapper>
						</Content>
					</Drawer>
				</Container>
			)}
		</>
	);
};
